import React from "react";
import { createMarkup, isFieldError } from "../../helpers";

const Textarea = ({
	label,
	note = "",
	reqd,
	name,
	value,
	update,
	errors,
	autocomplete = name,
	placeholder = "",
	taller = false,
}) => {
	return (
		<div className={isFieldError(errors, name) ? "has-error" : ""}>
			<label htmlFor={name} className="control-label">
				<span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
				{reqd && <span className="reqd">*</span>}
			</label>
			<textarea
				name={name}
				id={name}
				defaultValue={value || ""}
				onChange={(e) => update(name, e.target.value)}
				autoComplete={autocomplete}
				placeholder={placeholder}
				className={
					isFieldError(errors, name)
						? "form-control error-border"
						: "form-control"
				}
				style={{ height: taller ? "150px" : "inherit" }}
			/>
			<span className={note ? "note" : "hidden"}>{note}</span>
		</div>
	);
};

export default Textarea;
